// extracted by mini-css-extract-plugin
export default {"signatureCard":"signatureCard_signatureCard__rn3sO","imageUrl":"signatureCard_imageUrl__pFfA2","label":"signatureCard_label__gRKY4"};